var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TaskCardDetail',{attrs:{"task":_vm.task,"selected":_vm.selected,"show-checkbox":"","navigation-mode":"route","checklist-id":_vm.checklistId,"tasklist-view":_vm.tasklistView,"data-testid":"horizon-task-card"},on:{"selection-change":function($event){return _vm.$emit('selection-change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }